import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import {
  FREQUENCY_ONCE,
  FREQUENCY_WEEKLY,
  FREQUENCY_MONTHLY,
  FREQUENCY_EVERY_OTHER_WEEK,
  FREQUENCY_WEEKLY_EVERY_WEEK,
  FREQUENCY_WEEKLY_EVERY_TWO_WEEKS,
} from '../../../../../models/donationsNew';

const FrequencySelector = ({
  frequency,
  frequencyEvery,
  disabled,
  onChange,
  disableWeekly = false,
  disableMonthly = false,
  disableEveryOtherWeek = false,
  isDonorLinkDonation = false,
}) => (
  <FormControl variant="standard" data-testid="frequency-selector">
    <FormLabel component="legend">Frequency</FormLabel>
    <RadioGroup name="frequency" value={frequency} row onChange={event => onChange(parseInt(event.target.value, 10))}>
      {!isDonorLinkDonation && (
        <FormControlLabel
          data-testid="frequency-once"
          control={
            <Radio
              color="secondary"
              disabled={disabled}
              checked={frequency === FREQUENCY_ONCE}
              value={FREQUENCY_ONCE}
            />
          }
          label="One time only"
        />
      )}
      <FormControlLabel
        data-testid="frequency-weekly"
        control={
          <Radio
            color="secondary"
            disabled={disabled || disableWeekly}
            checked={frequency === FREQUENCY_WEEKLY && frequencyEvery === FREQUENCY_WEEKLY_EVERY_WEEK}
            value={FREQUENCY_WEEKLY}
          />
        }
        label="Weekly"
      />
      <FormControlLabel
        data-testid="frequency-monthly"
        control={
          <Radio
            color="secondary"
            disabled={disabled || disableMonthly}
            checked={frequency === FREQUENCY_MONTHLY}
            value={FREQUENCY_MONTHLY}
          />
        }
        label="Monthly"
      />
      <FormControlLabel
        data-testid="frequency-every_other_week"
        control={
          <Radio
            color="secondary"
            disabled={disabled || disableEveryOtherWeek}
            checked={frequency === FREQUENCY_WEEKLY && frequencyEvery === FREQUENCY_WEEKLY_EVERY_TWO_WEEKS}
            value={FREQUENCY_EVERY_OTHER_WEEK}
          />
        }
        label="Every other week"
      />
    </RadioGroup>
  </FormControl>
);

export default FrequencySelector;
